import { MMKV } from 'react-native-mmkv';
const isServer = typeof window === 'undefined';
class SSRShim {
    _data = {};
    getString(key) { return this._data[key]?.toString(); }
    set(key, value) { this._data[key] = value; }
    delete(key) { delete this._data[key]; }
    getAllKeys() { return []; }
}
export const storage = isServer ? new SSRShim() : new MMKV();
//# sourceMappingURL=mmkv-store.js.map